module.exports = __webpack_public_path__ + "img/logo.315bc5e1.png";